import React from 'react'
import { ClockCircleOutlined } from '@ant-design/icons';

import { statusInfo } from './Utils';
import { HeaderWrapper } from './style';

const Header = ({ handleComplete, setActiveTab, onHandleHere, activeTab, img }) => {

    const currentStatus = statusInfo[handleComplete];
    const renderHeaderContent = () => {
        switch (activeTab) {
            case '0':
                return (
                    <div className={currentStatus.state === 'submitted for processing' ? 'submit-state-header' : 'business-content'}>
                        <h3 className="business-header">Operator verification</h3>
                        <p>Please provide the name and contact of the person operating the platform. </p>
                        <p>The details collected are for compliance measures and are standard AML, KYC and CTF information. </p>
                        <p className="business-content-details">In addition to the operator's identity information the relevant business documentations </p>
                        <p>and information on the intended use of HollaEx will be required
                            {/* <Link onClick={() => setActiveTab('1')}>here.</Link> */}
                        </p>
                    </div>
                )
            case '1':
                return (
                    <div className={handleComplete === 4 ? 'submit-state-header' : 'business-content'}>
                        <h3 className="business-header">Business registered information</h3>
                        <p>Provide the necessary business/company documentation,</p>
                        <p>and share the relevant information on the nature of the business.</p>
                    </div>
                )
            case '2':
                return (
                    <div className={'business-content'}>
                        <h3 className="business-header">Sign user agreement</h3>
                        <p className="header-content">To sign and complete the user agreement section, the operator verification sections must be completed first.</p>
                    </div>
                )
            default:
                return ''
        }
    }

    return (
        <HeaderWrapper>
            <div className="headerWrapper">
                <div className={currentStatus.state === 'submitted for processing' ? 'submit-state-img' : 'img-field'}>
                    <img src={currentStatus.image[img]}
                        width='50px'
                        height='40px'
                        alt='profile' />
                    <div className='status-container'>
                        <div>
                            <div className="white-text">Status:</div>
                            <div className={`header-status ${currentStatus.className}`} >{currentStatus.state}</div>
                        </div>
                    </div>
                </div>
                {renderHeaderContent()}
            </div>
            {currentStatus.state === 'submitted for processing' &&
                <div className="submit-content-wrapper d-flex">
                    <div className="submit-message d-flex">
                        <ClockCircleOutlined className="clock-icon" />
                        <div>It may take 24 hours for the verification to complete.</div>
                    </div>
                </div>
            }
        </HeaderWrapper>
    )
}

export default Header